import { Close } from '@mui/icons-material';
import { Box, Drawer, Typography } from '@mui/material';

import { AppRoutes } from '../../../constants/routes';
import headerLogo from '../../../assets/imgs/logo.png';
import { useNavContext } from '../../../providers/navigation/navigation.provider';

import CustomNavLink from '../nav-link/nav-link.component';

import { useDrawerNavStyles } from './drawer-nav.styles';
import { body2 } from '../../../shared/theme/text.styles';

const DrawerNav = () => {
  const { toggleSideNav, sideNavOpen } = useNavContext();

  const classes = useDrawerNavStyles();

  return (
    <Drawer open={sideNavOpen} onClose={toggleSideNav} anchor='left'>
      <Box className={classes.dnWrapper}>
        <Box display='flex' alignItems='center' justifyContent='center'>
          <Box className={classes.brandLogo}>
            <img src={headerLogo} alt='graphsala' className='img-logo' />
          </Box>
        </Box>
        <div className={classes.dnClose}>
          <Close onClick={toggleSideNav} />
        </div>

        <Box component='ul' className={classes.dnLinks}>
          <CustomNavLink route={AppRoutes.WORKS} />
          <CustomNavLink route={AppRoutes.JOBS} />
          <CustomNavLink route={AppRoutes.ABOUT} />
          <CustomNavLink route={AppRoutes.CONTACT_US} />
        </Box>
      </Box>
    </Drawer>
  );
};
export default DrawerNav;
